export enum CmpConfigStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE"
}

export const CMP_CONFIG_STATUSES = [
    CmpConfigStatus.ACTIVE,
    CmpConfigStatus.INACTIVE
];
